import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../DefaultService';
import {
  IVideoProcessingQueueDeviceOptionProps,
  IVideoProcessingQueueFilterProps,
  IVideoProcessingQueueProps,
} from './types';

const ENDPOINT = '/v1/sport-video-queue';

export const getVideoProcessingQueueAsync = async (
  filter?: IVideoProcessingQueueFilterProps,
): Promise<IVideoProcessingQueueProps> => {
  try {
    const response = await api.get(ENDPOINT, { params: filter });
    return response.data;
  } catch (error) {
    throw new Error(toUserMessage(error));
  }
};

export const getVideoProcessingQueueDevicesAsync = async (): Promise<
  IVideoProcessingQueueDeviceOptionProps[]
> => {
  try {
    const response = await api.get(`${ENDPOINT}/devices`);
    return response.data;
  } catch (error) {
    throw new Error(toUserMessage(error));
  }
};

export const retryVideoProcessingAsync = async (id: number): Promise<void> => {
  try {
    await api.post(`/v1/sports/videos/${id}/retry`);
  } catch (error) {
    throw new Error(toUserMessage(error));
  }
};

// Roda em background via Hangfire (mesmo padrão do reenvio em lote de eventos esportivos) — o
// backend cria o job e retorna na hora, o front acompanha via useJobQuery/polling.
export const retryVideosBulkAsync = async (ids: number[]): Promise<{ jobId: number }> => {
  try {
    const response = await api.post('/v1/sports/videos/retry-bulk', { ids });
    return response.data;
  } catch (error) {
    throw new Error(toUserMessage(error));
  }
};
